/** Convert CMS HTML titles to text. Render the result as React text, never HTML. */
export const plainText = (value: string) => {
  const named: Record<string, string> = { amp: '&', nbsp: ' ', quot: '"', apos: "'", lt: '<', gt: '>', ndash: '–', mdash: '—', hellip: '…', lsquo: '‘', rsquo: '’', ldquo: '“', rdquo: '”' };
  return (value || '').replace(/<[^>]*>/g, '').replace(/&(#x[\da-f]+|#\d+|[a-z]+);/gi, (entity, key: string) => {
    if (key[0] !== '#') return named[key.toLowerCase()] ?? entity;
    const point = key[1].toLowerCase() === 'x' ? parseInt(key.slice(2), 16) : Number(key.slice(1));
    return point > 0 && point <= 0x10ffff && !(point >= 0xd800 && point <= 0xdfff) ? String.fromCodePoint(point) : entity;
  }).replace(/\s+/g, ' ').trim();
};

/** Only absolute HTTP(S) source URLs supplied by the CMS are clickable. */
export const articleSource = (value: string) => {
  try {
    const url = new URL(value);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null;
    return { href: url.href, label: url.hostname.replace(/^www\./, '') };
  } catch (_error) { return null; }
};

/** Import tool's explicit attribution marker distinguishes summaries from our reference guides. */
export const pressSource = (html: string, categorized = false) => {
  if (!categorized && !/Nội dung được An Thư tóm lược từ bài gốc/i.test(plainText(html))) return null;
  const section = html.match(/<h[1-6]\b[^>]*>\s*Nguồn tham khảo\s*<\/h[1-6]>([\s\S]*)/i)?.[1];
  if (!section) return null;
  const anchor = section.match(/<a\b[^>]*\bhref\s*=\s*["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/i);
  const source = anchor && articleSource(plainText(anchor[1]));
  if (!source || /(^|\.)(anthu\.today|anthu\.vn)$/.test(new URL(source.href).hostname)) return null;
  return { ...source, label: plainText(anchor![2]) || source.label };
};
